import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import React, { useContext, useEffect, useState } from "react";
import { Box, Button } from "@mui/material";

export default function NotFound() {
  const dispatch = useDispatch();
  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: false, title: "", menu: false }));
  }, [init]);

  useEffect(() => {
    dispatch(loadAction({ back: false, title: "", menu: false }));
  }, []);

  return (
    <div className="error-page container">
      <div className="cont">
        <Box className="illust">
          <img src={`${process.env.PUBLIC_URL}/images/img/nopage.svg`} />
        </Box>
        <h3>페이지를 찾을 수 없습니다</h3>
        <p className="color-info-sm">
          방문하시려는 페이지의 경로가 잘못되었거나
          <br />
          페이지가 변경 혹은 삭제되어 요청하신
          <br />
          페이지를 찾을 수 없습니다.
          <br />
          <br />
          메가마트 서비스 관련 궁금하신 사항은
          <br />
          메가마트 고객센터에서 확인해 주세요.
        </p>
      </div>
      <Button href="/" fullWidth variant="contained" color="primary">
        메인으로 돌아가기
      </Button>
    </div>
  );
}
